import { render } from "./DateOfBirthInput.vue?vue&type=template&id=60b6a391"
import script from "./DateOfBirthInput.vue?vue&type=script&lang=js"
export * from "./DateOfBirthInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__